var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none kf-dl",attrs:{"small":"","outlined":"","loading":_vm.busy,"disabled":_vm.busy || _vm.disabled},on:{"click":_vm.run}},[_c('LucideIcon',{staticClass:"mr-1",attrs:{"name":"download","size":15}}),_vm._v(" "+_vm._s(_vm.busy ? "Preparing…" : _vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }